import type { ActionModel } from '@jet/environment/types/models';

type ContextMenuPerformActionType =
    | 'library'
    | 'favorite'
    | 'addToPlaylist'
    | 'copy'
    | 'share'
    | 'edit-playlist';

export interface ContextualMenuPerformAction extends ActionModel {
    $kind: 'contextualMenuPerformAction';
    url: string;
    type?: ContextMenuPerformActionType;
    payload: unknown;
}

export function makeContextualMenuPerformAction(
    type: ContextMenuPerformActionType,
    url: string,
    payload: unknown,
): ContextualMenuPerformAction {
    return {
        $kind: 'contextualMenuPerformAction',
        type,
        url,
        payload,
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
}
